export default __webpack_public_path__ + "static/media/mode-9.a570a8a4.svg";